module.exports = __webpack_public_path__ + "img/casa.eb07c3a7.jpg";